import { Icon, Icons, Intent } from "construct-ui";
import ViewBase from "../../view-base.view";

/**
 * Monitoring Report File Content - Table row component
 * 
 * 
 * 
 * @author cmc.nttruong1
 */

export default function MonitoringReportFileContentDetailComponent() {
  ViewBase.call(this);

  const STATIC_COLUMNS = {
    CLIENT_CODE: 'CLIENT_CODE',
    FILE_NAME: 'FILE_NAME',
    FILE_TYPE: 'FILE_TYPE',
    UPLOAD_DATE: 'UPLOAD_DATE',
    PROCESS_DATE: 'PROCESS_DATE',
    TOTAL_COUNT: 'TOTAL_COUNT',
    TOTAL_SUCCESS: 'TOTAL_SUCCESS',
    PROCESSED: 'PROCESSED',
    TOTAL_FAIL: 'TOTAL_FAIL',
  }

  const BG_COLOR_SUCCESS = 'var(--is-success-green)';
  const BG_COLOR_FOOT = 'var(--bs-gray-200)';

  let expandDetail = false;
  let contentReport = {};
  let listData = [];

  const _expandDetailTable = () => {
    expandDetail = !expandDetail;
  }

  const validateDynamicValues = (key) => {
    let totalColumnValue = 0;
    listData.map((item) => {
      totalColumnValue += item[key];
    })
    return totalColumnValue;
  }

  const isNewItem = (item) => {
    return (item[STATIC_COLUMNS.PROCESSED] + item[STATIC_COLUMNS.TOTAL_FAIL] + item[STATIC_COLUMNS.TOTAL_SUCCESS]) == 0;
  }

  return {
    oninit: (vnode) => {
      contentReport = vnode.attrs.data;
      contentReport.listData?.map(i => listData.push({ ...i }));
    },
    view: (vnode) => {
      return [
        /** ROW CONTENT */
        m('tr.align-middle',
          m('td.text-center', contentReport.clientCode),
          m('td.text-center', contentReport.totalFiles),
          m('td.text-center', vnode.attrs.format(contentReport.success / contentReport.records) || 0),
          m('td.text-center', contentReport.records),
          m('td.text-center', contentReport.success),
          m('td.text-center', contentReport.processed),
          m('td.text-center', contentReport.errors),
          m('td.text-center',
            m(Icon, {
              intent: Intent.PRIMARY,
              name: Icons.CHEVRON_RIGHT,
              onclick: _expandDetailTable,
              title: this.getText('LT00008066', 'Detail'),
            }),
          ),
        ),

        /* SUB TABLE */
        expandDetail && listData.length > 0 &&
        m('tr',
          m('td', {
            colspan: 8,
            style: { 'max-width': '1100px' }
          },
            m('.table-responsive',
              m('table.table.table-hover.table-bordered',
                m('thead',
                  m('tr.align-end',
                    m('th.text-center', this.getText('LT00000883', 'File Name')),
                    m('th.text-center', this.getText('LT00008055', 'File Type')),
                    m('th.text-center', this.getText('LT00008068', 'Upload Date')),
                    m('th.text-center', this.getText('LT00008069', 'Process Date')),
                    m('th.text-center', this.getText('LT00008061', 'Success Rate (%)')),
                    m('th.text-center', this.getText('LT00008062', 'Records')),
                    m('th.text-center', this.getText('LT00008063', 'Success')),
                    m('th.text-center', this.getText('LT00008064', 'Processed')),
                    m('th.text-center', this.getText('LT00008065', 'Errors')),
                    //dynamic columns header
                    Object.keys(listData[0]).map((key) => {
                      if (!STATIC_COLUMNS[key] && validateDynamicValues(key)) {
                        return m('th.text-center', {
                          style: {
                            'white-space': 'break-spaces',
                          }
                        }, key.replaceAll('_', ' '))
                      }
                    }),
                  )
                ),
                m('tbody',
                  listData.map((item) => [
                    m('tr.align-middle',
                      {
                        style: {
                          'background-color': isNewItem(item) ? BG_COLOR_SUCCESS : '',
                        },
                      },
                      m('td.text-center', item[STATIC_COLUMNS.FILE_NAME]),
                      m('td.text-center', item[STATIC_COLUMNS.FILE_TYPE]),
                      m('td.text-center', item[STATIC_COLUMNS.UPLOAD_DATE]),
                      m('td.text-center', item[STATIC_COLUMNS.PROCESS_DATE]),
                      m('td.text-center', vnode.attrs.format(item[STATIC_COLUMNS.TOTAL_SUCCESS] / item[STATIC_COLUMNS.TOTAL_COUNT]) || 0),
                      m('td.text-center', item[STATIC_COLUMNS.TOTAL_COUNT]),
                      m('td.text-center', item[STATIC_COLUMNS.TOTAL_SUCCESS]),
                      m('td.text-center', item[STATIC_COLUMNS.PROCESSED]),
                      m('td.text-center', item[STATIC_COLUMNS.TOTAL_FAIL]),
                      // dynamic columns item
                      Object.keys(item).map((key) => {
                        if (!STATIC_COLUMNS[key] && validateDynamicValues(key)) {
                          return m('td.text-center', item[key]);
                        }
                      }),
                    )
                  ]),
                ),
                m('tfoot',
                  m('tr.align-middle',
                    { style: { 'background-color': BG_COLOR_FOOT } },
                    m('th.text-end', { colspan: 4 }, this.getText('LT00000046', 'Total')),
                    m('td.text-center', vnode.attrs.format(contentReport.success / contentReport.records) || 0),
                    m('td.text-center', contentReport.records),
                    m('td.text-center', contentReport.success),
                    m('td.text-center', contentReport.processed),
                    m('td.text-center', contentReport.errors),
                    // sub total each dynamic columns

                    Object.keys(listData[0]).map((key) => {
                      if (!STATIC_COLUMNS[key] && validateDynamicValues(key)) {
                        return m('td.text-center', validateDynamicValues(key))
                      }
                    }),
                  )
                )
              )
            ),
          )
        ),

        this.getBaseViews()
      ]
    }
  }
}